import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  public GetUserList: any;

  /**
   * Base URL for all CRUD endpoints (orders, users, service-types, etc.).
   * Sourced from src/environments/environment.ts (replaced at build time
   * with environment.sandbox.ts / environment.prod.ts via angular.json).
   *
   * Trailing slash is preserved so existing callers like
   *   `this.BASEURL + 'users'`
   * continue to produce well-formed URLs.
   */
  public BASEURL = environment.apiUrlSlash;

  /** Human-readable label of the environment this build is wired to. */
  public environment = environment.envName;

  constructor(protected http: HttpClient) {}
}
